export default "__VITE_PUBLIC_ASSET__bbb5dfef__"